import styled from 'styled-components';

export const WrapperLoader = styled.div`
  width: 100%;
  height: 100%;
`;
